<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar
        color="transparent"
        class="elevation-0 pa-0 page-header-toolbar"
      >
        <page-header-title :title="$t('changelog.title')"></page-header-title>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <ChangeLog :content="content" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { ChangeLog } from "@brakomp/ui"

export default {
  name: "ChangelogPage",

  components: { ChangeLog },

  data() {
    return {
      content: null,
    }
  },

  created() {
    import("@/assets/changelog.md?raw").then(module => {
      this.content = module.default
    })
  },
}
</script>
